import PixelMotionPlatform from '../platform/pixelmotion';

new PixelMotionPlatform().init();
